import { ThunkAction } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import { rootReducer } from "./rootReducer";

export type RootState = ReturnType<typeof rootReducer>;

export type Thunk<R> = ThunkAction<R, RootState, void, AnyAction>;

export { store } from "./store";
